var exports = {
  "o": "Token__uXxghu",
};

module.exports = exports;
